const packageDetailPage = document.querySelector('.package-detail-page');

if (packageDetailPage) {
    const packageId = packageDetailPage.dataset.id;
    const minPackagePrice = packageDetailPage.dataset.minPackagePrice;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        dynx_itemid: packageId,
        dynx_pagetype: 'offerdetail',
        dynx_totalvalue: minPackagePrice,
    });
}
